import { colors } from '@/styles/theme/foundations/colors';
import { radii } from '@/styles/theme/foundations/radius';
import { space } from '@/styles/theme/foundations/space';

export const formContaier = {
  padding: space[6],
  background: colors.background.nestedContainer.dark,
  borderRadius: radii.lg,
};
